import React from 'react';
import './ThresholdLegend.less';

const ThresholdLegend = (props) => {
    const { areaLegend } = props;
    return (
        <div className="threshold-legend-container">
            <div className="threshold-legend-header">占有率のしきい値</div>
            <div className="threshold-legend-content">
                <div className='threshold-legend-column'>
                    {areaLegend.map((item, index) => (
                        <div className="threshold-legend-item-color" style={{ backgroundColor: item.color }}></div>
                    ))}
                </div>

                <div className='threshold-legend-column'>
                    {areaLegend.length === 5 && (
                        <>
                            <div className="threshold-legend-item-label">{areaLegend[0].label}</div>
                            <div className="threshold-legend-item-icon-union-arrow-down">
                                <img src='assets/img/union-arrow-down.svg' alt="Arrow Down" className="threshold-legend-arrow-icon" />
                            </div>
                            <div className="threshold-legend-item-label">{areaLegend[4].label}</div>
                        </>
                    )}
                </div>

                <div className='threshold-legend-column'>
                    {areaLegend.map((item, index) => (
                        <div className="threshold-legend-item-value">{item.value}</div>
                    ))}
                </div>
            </div>
        </div>
    );
}

export default ThresholdLegend;